import { render, staticRenderFns } from "./DetailBrand.vue?vue&type=template&id=35e24b38&scoped=true"
import script from "./DetailBrand.vue?vue&type=script&lang=js"
export * from "./DetailBrand.vue?vue&type=script&lang=js"
import style0 from "./DetailBrand.vue?vue&type=style&index=0&id=35e24b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e24b38",
  null
  
)

export default component.exports